import { createContext, useContext, useEffect, useState } from "react";
import mqtt from "mqtt";
import toast, { Toaster } from "react-hot-toast";
import { useAuth } from "./AuthContext";
import SystemMessage from "../components/ui/SystemMessage";

const ACTION_STATUS_MAP = {
    START_CALL: "TALKING",
    END_CALL: "IDLE",
    RINGING: "RINGING",
};


const MQTTContext = createContext(null);

export const MQTTProvider = ({ children }) => {
    const [agentStatus, setAgentStatus] = useState("IDLE");
    const [callerInfo, setCallerInfo] = useState({ action: null, caller_id: null });
    const { isLoggedIn, selectedDevice } = useAuth();

    useEffect(() => {
        if (!isLoggedIn || !selectedDevice?.serial_key) return;

        const client = mqtt.connect(process.env.REACT_APP_MQTT_BROKER_URL, {
            username: process.env.REACT_APP_MQTT_USERNAME,
            password: process.env.REACT_APP_MQTT_PASSWORD,
        });

        client.on("connect", () => {
            const topic = `v1/devices/${selectedDevice.serial_key}/commands`;
            client.subscribe(topic);
            console.log("MQTT 연결 성공:", process.env.REACT_APP_MQTT_BROKER_URL);
            console.log("MQTT 구독 토픽:", topic);
        });

        client.on("message", (topic, message) => {
            try {
                const payload = JSON.parse(message.toString());

                toast(`[MQTT] ${topic}\n${JSON.stringify(payload)}`, {
                    duration: 4000,
                    style: {
                        background: "#000000",
                        color: "#FFFFFF",
                        fontFamily: "Pretendard",
                        fontSize: "12px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-all",
                    },
                });

                const newStatus = ACTION_STATUS_MAP[payload.action];
                if (newStatus) {
                    setAgentStatus(newStatus);
                    if (newStatus === "IDLE") {
                        setCallerInfo({ action: null, caller_id: null });
                    } else {
                        setCallerInfo({ action: payload.action, caller_id: payload.caller_id ?? null });
                    }
                }
            } catch (e) {
                console.error("MQTT 메시지 파싱 오류:", e);
            }
        });

        client.on("error", (e) => {
            console.error("MQTT 연결 오류:", e);
        });

        return () => client.end();
    }, [isLoggedIn, selectedDevice?.serial_key]);

    return (
        <MQTTContext.Provider value={{ agentStatus, setAgentStatus }}>
            <Toaster position="top-right" />
            <SystemMessage
                action={callerInfo.action}
                message={callerInfo.caller_id}
            />
            {children}
        </MQTTContext.Provider>
    );
};

export const useMQTT = () => useContext(MQTTContext);
